
import TrakkenButton from '~/components/ui/TrakkenButton.vue'
import { SimpleSVG } from 'vue-simple-svg'
export default {
  props: {
    logo: {
      type: String,
      required: false,
      default: null
    },
    background: {
      type: String,
      required: false,
      default: null
    },
    promoText: {
      type: String,
      required: false,
      default: null
    },
    isWide: {
      type: Boolean,
      required: false,
      default: false
    },
    mainHeader: {
      type: String,
      required: false,
      default: null
    },
    buttonURL: {
      type: String,
      required: false,
      default: null
    },
    buttonisAnchor: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonText: {
      type: String,
      required: false,
      default: null
    },
    scrollTo: {
      type: String,
      required: false,
      default: null
    },
    independentIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonAnchor: {
      type: String,
      required: false,
      default: null
    },
    link_isExternal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    TrakkenButton,
    SimpleSVG
  }
}
